// // Code review - In Progress
// // Documentation - In Progress

import React, { useState } from "react";
import { mainTable } from "../css/Common";
import InputPassword from "../ReusableComponents/InputPassword";
import { IUDAPI } from "../services/APIConnection";
import toast from "react-hot-toast";

const PasswordPopup = ({ closePopup }) => {
  const [password, setPassword] = useState(""); // old password
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [passwordError, setPasswordError] = useState(""); // old password error
  const [newPasswordError, setNewPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");

  const [passwordMatch, setPasswordMatch] = useState(true);

  const resetForm = () => {
    closePopup(true);
    setPassword("");
    setNewPassword("");
    setConfirmPassword("");

    setPasswordError("");
    setNewPasswordError("");
    setConfirmPasswordError("");
    setPasswordMatch(true);
  };

  const validatePassword = (value) => {
    return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[A-Za-z\d\S]{8,30}$/.test(
      value
    );
  };

  const handlePasswordChange = async () => {
    try {
      if (!password || !newPassword || !confirmPassword) {
        if (!password) setPasswordError("Enter old password");
        if (!newPassword) setNewPasswordError("Enter new password");
        if (!confirmPassword) setConfirmPasswordError("Enter confirm password");
        return;
      }

      if (newPassword !== confirmPassword) {
        setNewPasswordError("Passwords do not match");
        setConfirmPasswordError("Passwords do not match");
        return;
      }
       if (newPassword === password) {
        setNewPasswordError("New password must be different from old password"); 
        return;
      }

      const data = [
        {
          mstUserId: sessionStorage.getItem("createdBy"),
          oldPassword: password,
          newPassword: newPassword,
        },
      ];

      const response = await IUDAPI(data, "UserAPI/PasswordChange");
      const result = response?.data?.Table[0]?.Result;

      if (result === "Password updated successfully.") {
        toast.success("Password reset successful", {
          duration: 2000,
          position: "top-center",
        });
        resetForm();
      } else if (result === "Password not updated.") {
        toast.error("Incorrect old password.", {
          duration: 2000,
          position: "top-center",
        });
        setPasswordError("Incorrect old password.");
      } else {
        toast.error("Password reset failed", {
          duration: 2000,
          position: "top-center",
        });
      }
    } catch (error) {
      console.error("Error changing password:", error);
      toast.error("An unexpected error occurred. Please try again later.");
    }
  };

  const handleBlurOldPassword = async (value) => {
    setPassword(value);
    if (!value) {
      setPasswordError("Enter old password");
      return;
    }

    setPasswordError("");

    const data = [
      {
        mstUserId: sessionStorage.getItem("createdBy"),
        oldPassword: value,
        newPassword: "",
      },
    ];

    const response = await IUDAPI(data, "UserAPI/PasswordChange");
    const result = response?.data?.Table[0]?.Result;

    if (result === "Correct old password.") {
      setPasswordError("");
    } else { setPasswordError("Incorrect old password."); }
  };

  const handleBlurNewPassword = (value) => {
    setNewPassword(value);
    if (!value) {
      setNewPasswordError("Enter new password");
    } else if (value == password) {
      setNewPasswordError(
        "New password must be different from old password"
      );
    } 
    else if (!validatePassword(value)) {
      setNewPasswordError(
        "Password must have 8-30 characters including uppercase, lowercase, number, and special character"
      );
    } else {
      setNewPasswordError("");
    }
  };

  const handleBlurConfirmPassword = (value) => {
    setConfirmPassword(value);
    if (!value) {
      setConfirmPasswordError("Re-enter password");
      setPasswordMatch(true);
    } else {
      setConfirmPasswordError("");
      const match = newPassword === value;
      setPasswordMatch(match);
      if (!match) {
        setConfirmPasswordError("Passwords do not match");
      }
    }
  };

  return (
    <div className="w-full">
      <div className="text-xl mx-6 font-medium text-neutral-700">
        Change Password
      </div>
      <div className="text-center text-base px-2 text-neutral-700">
        Enter your old password to reset your password
      </div>
      <form className="mx-4">
        <div className="flex flex-col w-full">
          <div className="grid gap-4 mb-6">
            {/* Old Password */}
            <InputPassword
              title="Old Password"
              name="oldPassword"
              placeholder="Enter your old password"
              maxLength={30}
              content={password}
              controlFunc={(e) => setPassword(e.target.value)}
              controlFuncBlur={(e) => handleBlurOldPassword(e.target.value)}
            />
            {passwordError && (
              <div className="text-red-500">{passwordError}</div>
            )}

            {/* New Password */}
            <InputPassword
              title="New Password"
              name="newPassword"
              placeholder="Enter your new password"
              maxLength={30}
              content={newPassword}
              controlFunc={(e) => setNewPassword(e.target.value)}
              controlFuncBlur={(e) => handleBlurNewPassword(e.target.value)}
            />
            {newPasswordError && (
              <div className="text-red-500">{newPasswordError}</div>
            )}

            {/* Confirm Password */}
            <InputPassword
              title="Confirm Password"
              name="confirmPassword"
              placeholder="Re-enter your password"
              maxLength={30}
              content={confirmPassword}
              controlFunc={(e) => setConfirmPassword(e.target.value)}
              controlFuncBlur={(e) => handleBlurConfirmPassword(e.target.value)}
            />
            {confirmPasswordError && (
              <div className="text-red-500">{confirmPasswordError}</div>
            )}
            {!confirmPasswordError && !passwordMatch && (
              <div className="text-red-500">Passwords do not match</div>
            )}

            {/* Buttons */}
            <div className="flex justify-center p-3 space-x-2 items-baseline border-gray-200 rounded-b">
              <button
                type="button"
                className={mainTable.submitButton}
                onClick={handlePasswordChange}
              >
                Change Password
              </button>
              <button
                type="button"
                className={mainTable.cancelButton}
                onClick={resetForm}
              >
                CANCEL
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default PasswordPopup;
